(() => {
  if (customElements.get('value-cards-video')) return;

  class ValueCardsVideo extends HTMLElement {
    connectedCallback() {
      this.modal = this.querySelector('tb-video-modal');
      this.triggers = Array.from(this.querySelectorAll('[data-vc-trigger]'));

      if (this.modal && this.triggers.length > 0) {
        this.triggers.forEach((trigger) => {
          trigger.addEventListener('click', (event) => {
            event.preventDefault();
            const url = trigger.dataset.videoUrl;
            if (url) this.modal.open(url, trigger);
          });
        });
      }

      // Carousel navigation
      this.track = this.querySelector('[data-vc-track]');
      this.prevBtn = this.querySelector('[data-vc-prev]');
      this.nextBtn = this.querySelector('[data-vc-next]');

      if (!this.track || (!this.prevBtn && !this.nextBtn)) return;

      const scrollByPage = (dir) => {
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        this.track.scrollBy({
          left: (this.track.clientWidth + gap) * dir,
          behavior: 'smooth',
        });
      };

      const updateNavState = () => {
        const atStart = this.track.scrollLeft <= 1;
        const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 1;
        if (this.prevBtn) this.prevBtn.disabled = atStart;
        if (this.nextBtn) this.nextBtn.disabled = atEnd;
      };

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => scrollByPage(-1));
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => scrollByPage(1));
      }

      this.track.addEventListener('scroll', updateNavState, { passive: true });
      window.addEventListener('resize', updateNavState);
      updateNavState();
    }
  }

  customElements.define('value-cards-video', ValueCardsVideo);
})();
